/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgeUnitoServicenowDevIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-servicenow-dev" */ './utils').then(
			(m) => m.ForgeUnitoServicenowDevIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-servicenow-dev/icon' },
);

const LazyForgeUnitoServicenowDevSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-servicenow-dev-search-result" */ './utils').then(
			(m) => m.ForgeUnitoServicenowDevSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-servicenow-dev/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgeUnitoServicenowDevIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeUnitoServicenowDevIconComponent />
	</Suspense>
);

export const ForgeUnitoServicenowDevSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeUnitoServicenowDevSearchResultIconComponent />
	</Suspense>
);
